import React from 'react';
import { Stack } from '@mui/material';
import { ArabicToPersian } from 'utils/ConvertToPersianTextFromArabic';

import i18next from 'i18next';
import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';

const LabPatientInformation = ({
  content,
  setOpenOperation,
  openOperation,
}) => {
  const isEnglish = i18next.language === 'en';
  const textAlign = isEnglish ? 'left' : 'right';

  const req_type_label = FindLangKey(
    'lab-patient-number-request'
  );
  const label_patient = FindLangKey(
    'general-public-label-patient'
  );
  const answer_date_label = FindLangKey(
    'lab-patient-tarikh-type-javab-dehi'
  );
  const confirmed = FindLangKey(
    'general-public-label-confirmed'
  );
  const LamNumber = FindLangKey('patologoy-lab-lam-number');

  const patient_id = FindLangKey('new-referral-label-id');

  const operation_open = JSON.parse(
    sessionStorage.getItem('lab')
  );

  return (
    <React.Fragment>
      <div
        onClick={() => {
          setOpenOperation((prev) => {
            const el = !prev.includes(content?.FldId)
              ? [...prev, content?.FldId]
              : prev.filter((fl) => fl !== content?.FldId);

            sessionStorage.setItem(
              'lab',
              JSON.stringify(el)
            );
            return el;
          });
        }}
      >
        <Stack gap=".5em">
          <p
            style={{
              textAlign,
            }}
          >
            {LamNumber} : 
            <span style={{ textAlign: 'left' }}>
              {content?.LamNumber}
            </span>
          </p>
          <p
            style={{
              textAlign,
            }}
          >
            {patient_id} : {content?.FldIdPatient}
          </p>
          <p
            style={{
              textAlign,
            }}
          >
            {label_patient} : 
            {ArabicToPersian(content?.NamePatient)}
          </p>

          {/* {content.FldConfermDoctor ? (
            <p
              style={{
                textAlign,
                color: 'green',
              }}
            >
              {confirmed}
            </p>
          ) : (
            <></>
          )} */}
        </Stack>
      </div>
    </React.Fragment>
  );
};

export default LabPatientInformation;
